<div class=" ">

  <nav class="navbar navbar-expand-lg navbar-dark bg-dark justify-content-between">
    <div class="container-fluid">
      <a class="navbar-brand" [routerLink]="['/home']">Inicio</a>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">

          <li class="nav-item">
            <a class="nav-link active" aria-current="page" [routerLink]="'/diputados'">Diputados</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</div>